import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Button, withStyles } from "@material-ui/core";
import { SelectWithLabel } from "../../utils/selectWithLabel";
import { loadFlights } from "../../store/flights";
import { formatFlightDate } from "./flightFunctions";
import styles from "./styles";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import moment from 'moment';
import Headers from "../dcs/headers/Headers";
import { loadDepartures, changeDepartureDate, changeDestination, changeFlightNumber, changeOrigin, changePassenger, changeRloc, changeTailNumber, changeStatus } from "../../store/dcs";
const regionChoices = [
  { label: 'Northeast', value: 'Northeast' },
  { label: 'Caribbean', value: 'Caribbean' },
  {label: 'Caribbean/SE', value:'Caribbean/SE'}
]

const statusChoices = [
  { label: 'Active', value: 'Active' },
  { label: 'Cancelled', value: 'Cancelled' }
]

const getFilterStyle = () => {
  let screenWidth = window.innerWidth
  let filterStyle = { marginLeft: '1%', marginRight: '1%', width: '75%' }
  if (screenWidth > 600 && screenWidth < 800) {
    filterStyle.width = '18%'
  }
  else if (screenWidth >= 800) {
    filterStyle.width = '13%'
  }
  return filterStyle
}

// NOTE // when changing days with a selected airport, if the airport is not on any flights that day, it dissapears
// NOTE // this adds the selected airport(s) to the current choices
const getCurAirportChoices = (filters) => {
  let choices = []
  let origin = filters.origin.val
  let dest = filters.dest.val
  if (Array.isArray(origin) && Array.isArray(dest)) {
    let airports = [].concat(origin, dest)
    // NOTE // each choice needs a label and value prop
    choices = airports.map(apt => { return { label: apt, value: apt } })
  }

  return choices
}

// NOTE // getting airport choices based on current flights origin and destination airports (this is what they wanted)
const getAirportChoices = (flightsArr, filters) => {
  let airportChoices = getCurAirportChoices(filters)

  // NOTE // looping over flights and adding their airports to airportChoices
  if (flightsArr && Array.isArray(flightsArr) && flightsArr.length >= 1) {
    for (let i = 0; i < flightsArr.length; i++) {
      const flight = flightsArr[i]
      let origin = flight.Origin
      let dest = flight.Destination
      if (origin && dest) {
        // NOTE // combining current airportChoices with the airports from the flight
        airportChoices = airportChoices.concat([{ label: origin, value: origin }, { label: dest, value: dest }])
      }
    }
  }

  // NOTE // returning unique airport choices
  return _.uniqBy(airportChoices, 'value')
}

// NOTE // resets filters to their blank state (aside from the date)
const clearFilters = (filters) => {
  for (const filterType in filters) {
    const curFilter = filters[filterType]
    if (filterType === 'status') {
      curFilter.set(['Active'])
    }
    else if (filterType === 'date') {
      continue
    }
    curFilter.set([])
  }
}

const MobileFilters = (props) => {
  const { filters, airportChoices, isZwAirline } = props
  const dispatch = useDispatch()
  let filterStyle = getFilterStyle()
  const [date, setDate] = useState(props.filters.date.val);

  const handleNextClick = () => {
    const nextDates = moment(date).add(1, 'day');
    const currDate = new Date(date);
    currDate.setDate(currDate.getDate() + 1); // increase date by 1 day
    const nextDate = currDate.toISOString().slice(0, 10); // convert date object back to string
    setDate(nextDate);
    filters.date.set({ target: { value: nextDate } }); // update filters.date.val
    dispatch(loadFlights(formatFlightDate(nextDate)));
    dispatch(changeDepartureDate(nextDates.format('YYYY-MM-DD')));
  };

  const handlePreClick = () => {
    const currDate = new Date(date);
    const preDate = moment(date).subtract(1, 'day'); 
    currDate.setDate(currDate.getDate() - 1); // decrease date by 1 day
    const preDates = currDate.toISOString().slice(0, 10); // convert date object back to string
    setDate(preDates);
    filters.date.set({ target: { value: preDates } }); // update filters.date.val
    dispatch(loadFlights(formatFlightDate(preDates)));
    dispatch(changeDepartureDate(preDate.format('YYYY-MM-DD')));
  };

  return (
    <Grid container style={{ marginBottom: '10px', marginTop: '10px' }}>
      <Grid className="flightPageFilters leftheader-Mob">
        <Grid container className="dateNavigateBlock" justifyContent="center">
          <TextField
            id="fltDate"
            label="Flight Date"
            type="date"
            value={date}
            defaultValue={filters.date.val}
            style={{ marginLeft: '1%', marginRight: '1%', width: '75%' }}
            InputLabelProps={{ shrink: true }}
            onChange={(event) => {
              setDate(event.target.value);
              filters.date.set(event);
              dispatch(changeDepartureDate(moment(event.target.value).format('YYYY-MM-DD')));
              dispatch(loadDepartures(formatFlightDate(moment(event.target.value).format('YYYY-MM-DD'))));
            }}
          />
          <div className="navigateBtns">
            <Button className="nextPrev-btn" onClick={handlePreClick}>{"<<"}</Button>
            <Button className="nextPrev-btn" onClick={handleNextClick}>{">>"}</Button>
          </div>

        </Grid>
        <Grid>
          <Button variant="contained" size="small" style={{ height: '60%', marginTop: '10px', marginLeft: '12%' }} onClick={() => { clearFilters(filters) }}>Clear Filters</Button>
        </Grid>
        <Grid>
          <Button variant="contained" size="small" style={{ height: '60%', marginTop: '10px', marginLeft: '12%' }} onClick={() => { dispatch(loadFlights(formatFlightDate(filters.date.val))) }}>Refresh</Button>
        </Grid>
      </Grid>
      <Grid container className='flightPageFilters rightheader-Mob' alignContent="center">
        <Grid container justifyContent="center" item xs={3}>
          <SelectWithLabel defaultVal={filters.origin.val} handleChange={(e) => { filters.origin.set(e.target.value) }} inputLabel={'Origin'} items={airportChoices} multiple customStyle={filterStyle} />
        </Grid>
        <Grid container justifyContent="center" item xs={3}>
          <SelectWithLabel defaultVal={filters.dest.val} handleChange={(e) => { filters.dest.set(e.target.value) }} inputLabel={'Destination'} items={airportChoices} multiple customStyle={filterStyle} />
        </Grid>
       {!isZwAirline && <Grid container justifyContent="center" item xs={3}>
          <SelectWithLabel defaultVal={filters.region.val} handleChange={(e) => { filters.region.set(e.target.value) }} inputLabel={'Region'} items={regionChoices} multiple customStyle={filterStyle} />
        </Grid>}
        <Grid container justifyContent="center" item xs={3}>
          <SelectWithLabel defaultVal={filters.status.val} handleChange={(e) => { filters.status.set(e.target.value) }} inputLabel={'Status'} items={statusChoices} multiple customStyle={filterStyle} />
        </Grid>
      </Grid>
    </Grid>
  )
}

function RegularFilters(props) {
  const { filters, classes, airportChoices, isZwAirline } = props;
  const dispatch = useDispatch();
  const [date, setDate] = useState(moment(props.filters.date.val)); // initialize date with a moment object

  // NOTE // I'm keeping fitler because it's funny
  let fitlerStyle = getFilterStyle();

  const handleNextClick = () => {
    const nextDate = moment(date).add(1, 'day'); // increase date by 1 day using moment
    setDate(nextDate);
    filters.date.set({ target: { value: nextDate.format('YYYY-MM-DD') } }); // update filters.date.val with formatted string
    dispatch(loadFlights(formatFlightDate(nextDate.format('YYYY-MM-DD'))));
    dispatch(changeDepartureDate(nextDate.format('YYYY-MM-DD')));
  };

  const handlePreClick = () => {
    const preDate = moment(date).subtract(1, 'day'); // decrease date by 1 day using moment
    setDate(preDate);
    filters.date.set({ target: { value: preDate.format('YYYY-MM-DD') } }); // update filters.date.val with formatted string
    dispatch(loadFlights(formatFlightDate(preDate.format('YYYY-MM-DD'))));
    dispatch(changeDepartureDate(preDate.format('YYYY-MM-DD')));
  };

  return (
    <Grid container className='topDateBtnBlock' item xs={12} style={{ marginBottom: '10px', marginTop: '10px' }}>
      <Grid container className="topDate-Prev-Next-Btns flightPageFilters" alignContent="flex-end" item sm={4} md={4}>
        <TextField
          id="fltDate"
          label="Flight Date"
          type="date"
          value={date.format('YYYY-MM-DD')} // format moment object to string for input value
          defaultValue={props.filters.date.val}
          className={classes.textField}
          InputLabelProps={{ shrink: true }}
          onChange={(event) => {
            setDate(moment(event.target.value)); // update state with moment object
            filters.date.set(event);
            dispatch(changeDepartureDate(moment(event.target.value).format('YYYY-MM-DD')));
            dispatch(loadDepartures(formatFlightDate(moment(event.target.value).format('YYYY-MM-DD'))));
          }}
        />

        <Button className="nextPrev-btn" onClick={handlePreClick}>{"<<"}</Button>
        <Button className="nextPrev-btn" onClick={handleNextClick}>{">>"}</Button>
      </Grid>

      <Grid container className='flightPageFilters' justifyContent={window.innerWidth > 600 && window.innerWidth < 900 ? 'flex-start' : 'flex-end'} alignContent="center" item sm={8} md={8}>
        <Button variant="contained" size="small" style={{ marginLeft: '1%', marginRight: '1%', height: '60%', marginTop: '12px' }} onClick={() => { clearFilters(filters) }}>Clear Filters</Button>
        <Button variant="contained" size="small" style={{ marginLeft: '1%', marginRight: '1%', height: '60%', marginTop: '12px' }} onClick={() => { dispatch(loadFlights(formatFlightDate(filters.date.val))) }}>Refresh</Button>
        <SelectWithLabel defaultVal={filters.origin.val} handleChange={(e) => { filters.origin.set(e.target.value) }} inputLabel={'Origin'} items={airportChoices} multiple customStyle={fitlerStyle} />
        <SelectWithLabel defaultVal={filters.dest.val} handleChange={(e) => { filters.dest.set(e.target.value) }} inputLabel={'Destination'} items={airportChoices} multiple customStyle={fitlerStyle} />
       {!isZwAirline && <SelectWithLabel defaultVal={filters.region.val} handleChange={(e) => { filters.region.set(e.target.value) }} inputLabel={'Region'} items={regionChoices} multiple customStyle={fitlerStyle} />}
        <SelectWithLabel defaultVal={filters.status.val} handleChange={(e) => { filters.status.set(e.target.value) }} inputLabel={'Status'} items={statusChoices} multiple customStyle={fitlerStyle} />
      </Grid>
    </Grid>
  )
}

export const Filters = (props) => {
  let airportChoices = getAirportChoices(props.flights, props.filters)
  const location = useLocation();
  //user airlineId from redux
  const token = useSelector(state => state.entities.auth.token);
  const {airline_id} = token ? JSON.parse(window.atob(token.split('.')[1])) : '';

  const isZwAirline = airline_id === 'ZW';
 
  const isFlightsRoute = location.pathname === '/flights' || location.pathname === '/';
  const isDcsRoute = location.pathname === '/dcs' || location.pathname === '/';
  // NOTE // filterProps has origin, dest, status, region, and date objects. Each object has a val and set property for setting and checking filter data

  if (isFlightsRoute && props.isMobile) {
    return <MobileFilters {...props} airportChoices={airportChoices} isZwAirline={isZwAirline} />
  }
  else if (!isFlightsRoute) {
    return isDcsRoute && (
      <Headers {...props} airportChoices={airportChoices} />
    )
  }
  else {
    return (
      isFlightsRoute && (
        <RegularFilters {...props} airportChoices={airportChoices} isZwAirline={isZwAirline} />
      )
    );
  }
}

export default withStyles(styles)(Filters)